module.exports = __webpack_public_path__ + "media/landing-page/hero-76366b79.svg";